export default {
	id: "nexus9",
	title: "Nexus 9",
	company: "HTC",
	colorSide: true,
	styles: [
		{
			title: "normal",
			pos: ["10.2%", "6%", "10.5%", "5%"],
			colors: [
				{title: "Black", hex: "#000000", img: require("./original/black.png")}
			]
		}
	]
};
